import React, { memo, useEffect } from "react";
import styles from "./PresenterProfile.module.css";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { AppState } from "../../../root/RootReducer";
import { load } from "../../PresentersActions";
import PresenterCard from "../index/PresenterCard";
import { UserSkill } from "../../../user/User";
import { mapRolesToStrings } from "../../../user/User";
import { isAdmin, isEditor, isProfessional } from "../../../utils/LogicUtils";
import PencilIcon from "../../../common/components/icons/PencilIcon";
import NavButton from "../../../common/components/button/NavButton";

function PresenterProfile() {
    const {
        isLoading,
        userInfo,
        user
    } = useSelector((state: AppState) => ({
        isLoading: state.presenters.profile.isLoading,
        userInfo: state.presenters.profile.userInfo,
        user: state.user.user
    }));
    const dispatch = useDispatch();
    const {id} = useParams();

    const isSelfProfile = (id === `${user?.id}`);

    useEffect(() => {
        dispatch(load(id));
    }, [dispatch, user, id]);

    if (isLoading || !userInfo) {
        return (
            <div className={styles.loading}>
                Loading...
            </div>
        );
    }

    const { skills } = userInfo;

    return (
        <div className={styles.profile}>
            <div className={styles.info}>
                <PresenterCard userInfo={userInfo}/>

                {
                    (isAdmin(user?.roles) || isEditor(user?.roles)) &&
                    <div className={styles.role}>
                        <div className={styles.box}>
                            <div className={styles.boxHeader}>Role</div>
                            <div className={styles.boxItem}>
                                {mapRolesToStrings(userInfo)}
                            </div>
                        </div>

                        <div className={styles.editButton}>
                            <NavButton
                                fullWidth
                                color="white"
                                icon={<PencilIcon/>}
                                path={`/presenters/${id}/edit/roles`}
                            >
                                Edit role
                            </NavButton>
                        </div>
                    </div>
                }

                {
                    isProfessional(userInfo.roles) &&
                    <div className={styles.skills}>
                        <div className={styles.box}>
                            <div className={styles.boxHeader}>Skills</div>
                            {
                                skills.map((skill: UserSkill) => (
                                    <div
                                        key={skill.id}
                                        className={styles.boxItem}
                                    >
                                        {skill.skill}
                                    </div>
                                ))
                            }
                        </div>

                        {
                            (isAdmin(user?.roles) || isEditor(user?.roles) || isSelfProfile) &&
                            <div className={styles.editButton}>
                                <NavButton
                                    fullWidth
                                    color="white"
                                    icon={<PencilIcon/>}
                                    path={`/presenters/${id}/edit/skills`}
                                >
                                    Edit skills
                                </NavButton>
                            </div>
                        }
                    </div>
                }
            </div>
        </div>
    );
}

export default memo(PresenterProfile);
